import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-influence-for-good',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './influence-for-good.component.html',
  styleUrls: ['./influence-for-good.component.scss']
})
export class InfluenceForGoodComponent implements OnInit {
  isPlaying: Boolean = false;

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {
    this.titleService.setTitle("Influence for Good | Make a Positive Impact with Brandripplr");
    this.metaService.updateTag({ 
      name: 'description', 
      content: 'Learn how Brandripplr empowers influencers to make a positive change. Join us in shaping your brand through meaningful campaigns. Contact us!' 
    });
  }

  playPause() {
    const myVideo = document.getElementById("my_video_1") as HTMLVideoElement;
    if (myVideo.paused) { 
      this.isPlaying = true;
      myVideo.play();
    } else {
      this.isPlaying = false;
      myVideo.pause();
    }
  }

  ngOnInit(): void {
  }

}
